// 船期查询模块国际化 - 中文
export default {
  title: '船期查询',
  description: '查询海运船期信息和匹配运价',

  // 搜索区域
  search: {
    title: '船期查询',
    originPort: '起运港',
    destinationPort: '目的港',
    originPortPlaceholder: '请选择或输入起运港',
    destinationPortPlaceholder: '请选择或输入目的港',
    etd: 'etd',
    etdTime: '请选择日期',
    scheduleRange: '船期区间',
    selectScheduleRange: '请选择船期区间',
    oneWeek: '一周内',
    twoWeeks: '二周内',
    threeWeeks: '三周内',
    fourWeeks: '四周内',
    searchButton: '查询船期',
    resetButton: '重置'
  },

  // 查询结果
  results: {
    title: '查询结果',
    statsText: '共找到 {total} 条船期信息，其中 {withRates} 条有匹配运价',
    emptySearch: '请选择起运港和目的港进行查询',
    emptyResult: '暂无匹配的船期信息，请尝试其他港口或联系客服',
    syncingDescription: '正在调用第三方查询数据，预计需要5分钟，请稍后再试'
  },

  // 表格列标题
  columns: {
    routeInfo: '航线信息',
    spaceSharing: '共舱方',
    vessel: '船名航次',
    origin: '起运港',
    destination: '目的港',
    transit: '航程 & 服务',
    rates: '匹配运价'
  },

  // 共舱方信息
  spaceSharing: {
    internalVoyage: '内部航次',
    spaceAgent: '舱位船代',
    dangerousAgent: '危险品船代'
  },

  // 船名航次
  vesselVoyage: {
    sailingSchedule:'班次'
  },

  // 截止时间
  cutoff: {
    title: '截止时间',
    cargo: '码头进箱截止时间',
    doc: '截单',
    vgm: '截VGM',
    dangerous: '截危',
    cyOpen: '码头进箱开始时间',
    booking: '截订舱',
    custom: '截放行'
  },

  // 港口相关
  port:{
    terminalCode: '码头代码'
  },

  // 港口时间标签
  portTime: {
    eta: 'ETA',
    etd: 'ETD'
  },

  // 航程信息
  transit: {
    days: '天',
    direct: '直达',
    transfer: '中转',
    transitPortsInfo: '中转港信息',
    viaPortsText: '经{count}个港口'
  },

  // 运价模块
  rates: {
    // 有运价
    withRates: {
      title: '匹配运价',
      foundText: '找到 {count} 个运价方案',
      priceUnit: '起/20GP',
      viewDetails: '查看运价详情',
      inquireNow: '立即询价'
    },
    // 无运价
    noRates: {
      title: '暂无运价',
      description: '该船期暂无公开运价',
      inquireNow: '立即询价',
      inquiryNote: '专属销售为您第一时间报价'
    }
  },

  // 服务类型
  serviceType: {
    direct: '直达',
    transit: '中转'
  },

  // 消息提示
  messages: {
    selectPorts: '请选择起运港和目的港',
    loadDataFailed: '加载船期数据失败，请稍后重试',
    baseDataLoadFailed: '加载基础数据失败，请稍后重试'
  }
}
